// validarCpfCnpj.js
const validarCpfCnpj = async (cpfCnpj, erroCpfCnpj, nomeEmpresa, erroNomeEmpresa) => {
  if (!cpfCnpj || typeof cpfCnpj.value !== 'string') {
    console.error('[validarCpfCnpj] cpfCnpj inválido:', cpfCnpj)
    return
  }

  const valor = cpfCnpj.value.replace(/[^\d]+/g, '')

  if (valor.length === 11) {
    if (!validaCPF(valor)) {
      erroCpfCnpj.value = 'CPF inválido.'
    } else {
      erroCpfCnpj.value = ''
    }
  } else if (valor.length === 14) {
    if (!validaCNPJ(valor)) {
      erroCpfCnpj.value = 'CNPJ inválido.'
    } else {
      erroCpfCnpj.value = ''
      await buscarCNPJ(valor, nomeEmpresa, erroNomeEmpresa)
    }
  } else {
    erroCpfCnpj.value = 'Digite um CPF (11 dígitos) ou CNPJ (14 dígitos).'
  }
}

function validaCPF(cpf) {
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false
  let soma = 0
  for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i)
  let resto = (soma * 10) % 11
  if (resto === 10 || resto === 11) resto = 0
  if (resto !== parseInt(cpf.charAt(9))) return false
  soma = 0
  for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i)
  resto = (soma * 10) % 11
  if (resto === 10 || resto === 11) resto = 0
  return resto === parseInt(cpf.charAt(10))
}

function validaCNPJ(cnpj) {
  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false
  const calc = (base, peso) => base.reduce((s, d, i) => s + d * peso[i], 0)
  const base = cnpj.split('').map(Number)
  const peso1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const peso2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  let dig1 = calc(base.slice(0, 12), peso1) % 11
  dig1 = dig1 < 2 ? 0 : 11 - dig1
  if (dig1 !== base[12]) return false
  let dig2 = calc(base.slice(0, 13), peso2) % 11
  dig2 = dig2 < 2 ? 0 : 11 - dig2
  return dig2 === base[13]
}

async function buscarCNPJ(cnpj, nomeEmpresa, erroNomeEmpresa) {
  const cnpjLimpo = cnpj.replace(/\D/g, '')
  try {
    const res = await fetch(`https://publica.cnpj.ws/cnpj/${cnpjLimpo}`)
    const data = await res.json()

    if (!data.razao_social) {
      erroNomeEmpresa.value = 'CNPJ não encontrado.'
      nomeEmpresa.value = ''
    } else {
      nomeEmpresa.value = data.razao_social
      erroNomeEmpresa.value = ''
    }
  } catch (e) {
    erroNomeEmpresa.value = 'Erro ao buscar dados do CNPJ.'
    nomeEmpresa.value = ''
  }
}

export default validarCpfCnpj
